import { combineReducers } from "redux";
import setupSlice from "./slice/setup.slice";
import togglersSlice from "./slice/togglers.slice";
import profileSlice from "./slice/profile.slice";
import feedbackSlice from "./slice/feedback.slice";

const rootReducer = combineReducers({
  togglers: togglersSlice,
  profile: profileSlice,
  setup: setupSlice,
  feedback: feedbackSlice,
});

export default rootReducer;
